import "./serp.scss";

export const serp = {};